/**
 * This is to define action type constants.
 * 
 * Actions are used for asynchronous state management.
 */
export enum ActionTypes {
  // login and user actions
  USER_LOGIN = 'USER_LOGIN',
  USER_LOGOUT = 'USER_LOGOUT',
  SELECT_GAME = 'SELECT_GAME',
  SELECT_ROOM = 'SELECT_ROOM',
  ENTER_ROOM = 'ENTER_ROOM',
  USER_CONNECTED = 'USER_CONNECTED',

  // main game windows
  LOGIN_SHOWN = 'LOGIN_SHOWN',
  ROOMS_SHOWN = 'ROOMS_SHOWN',

  // settings
  SETTINGS = 'SETTINGS',
}
